export const WorkflowApprovalModuleTranslations: Array<string> = [
    // statuses
    'xmlStatuses',
    'Admin.StatusesDatatable.QuickSearch',
    'Admin.StatusesDatatable.ColumnName.StatusName',
    'Admin.StatusesDatatable.ColumnName.Rank',
    'Admin.StatusesDatatable.ColumnName.DefaultStatus',
    'Admin.StatusesDatatable.ColumnName.Editable',
    'Admin.StatusesDatatable.ColumnName.StatusOfLockedQuoteRevisions',
    'Admin.Statuses.AddNewButton',
    'Admin.StatusTranslation.StatusInfo',
    'Admin.StatusTranslation.StatusInfo.Name',
    'Actions.GenericAction.SaveSuccess',
    'Admin.StatusTranslation.Column.Label',
    'Admin.StatusTranslation.Column.DefaultLanguage',
    'Admin.CountryTranslation.SelectLanguage',
    'Admin.Statuses.StatusID',
    'Admin.Statuses.Locked',
    'Admin.Statuses.Default',
    'Admin.Msg.EditTitle',
    'Admin.MLDictionaries.Rank',

    // actions
    'xmlActions',
    'Admin.ActionsDatatable.QuickSearch',
    'Admin.ActionsDatatable.ColumnName.ActionName',
    'Admin.ActionsDatatable.ColumnName.Rank',
    'Admin.Actions.DisplayImages',
    'GENDOC.ONLYPREVIEWDOCUMENIFAPPROVALNEEDED',
    'GENDOC.EXEPREACTIONSIFONLYPREVIEWIFNOTAPPROVED',
    'Admin.Msg.AddNew',
    'Admin.Actions.DisplayInQuotes',
    'ActionsEdit.PrimaryAction',
    'Admin.Actions.Icon',
    'Admin.Actions.ResetToDefaultImage',
    'ActionsEdit.PrimaryActionHint',
    'Admin.Actions.ImageSizeInfo',
    'ActionsEdit.ActionCondition',
    'ActionsEdit.GlobalCondition',
    'Admin.ActionTranslation.ActionInfo',
    'Admin.ActionTranslation.SelectLanguage',
    'Admin.ActionTranslation.Column.DefaultLanguage',
    'Admin.MLDictionaries.Rank',
    'Admin.Multilanguage',
    'ActionsEdit.PreActionCondition',
    'ActionsEdit.PostActionCondition',
    'ActionsEdit.Placement',
    'AddEditCustomAction.DisplayOnQuote',
    'AddEditCustomAction.DisplayOnLoadQuote',
    'AddEditCustomAction.DisplayOnQuoteAndLoadQuote',
    'Admin.AddEditAction.Script',
    'Admin.AddEditAction.History',
    'Admin.AddEditAction.ScriptCode',
    'Admin.AddEditAction.ScriptCodeInfo',
    'Versions.SelectExactlyTwoVersionToCompare',
    'Admin.Actions.ModifiedBy',
    'Admin.Actions.ModifiedDate',
    'Admin.ActionsDatatable.ActionType.Standard',
    'Admin.ActionsDatatable.ActionType.Script',
    'Admin.ActionsDatatable.ColumnName.ActionType',
    'Admin.ActionsDatatable.ColumnName.Script',
    'Admin.ActionsDatatable.ColumnName.ModifiedDate',
    'Admin.ActionsDatatable.ColumnName.ModifiedBy',

    // itemActions
    'xmlItemActions',
    'Admin.ItemActions.ColumnName.ItemActionName',
    'Admin.ItemActionsTranslation.Column.Label',
    'Admin.ItemActionsTranslation.Column.DefaultLanguage',
    'Admin.ItemActionsTranslation.Column.SelectLanguage',
    'Admin.ItemActions.QuickSearch',

    // approval branch
    'Admin.ApprovalBranch.QuickSearch',
    'Admin.ApprovalBranch.Name',
    'Admin.ApprovalBranch.Description',
    'Admin.ApprovalBranch.UseOrLogic',
    'Admin.ApprovalBranch.DescriptionHint',
    'Admin.ApprovalBranch.UseOrLogicHint',
    'xmlApprovalBranch',
    'Admin.ApprovalBranch.BranchID',
    'Admin.ApprovalBranch.AddNewButton',
    'Admin.ApprovalBranchTranslation.ApprovalbranchInfo.Name',
    'Admin.ApprovalBranchTranslation.ApprovalbranchInfo.Description',
    'Admin.ApprovalBranchTranslation.ApprovalbranchInfo',
    'Admin.ApprovalBranchTranslation.Column.DefaultLanguage',
    'Admin.ApprovalBranchTranslation.Column.Label',
    'Admin.ApprovalBranchTranslation.SelectLanguage',

    // Approval Auto Reminder
    'Admin.ApprovalsAutoReminder.NewConfiguration',
    'Admin.ApprovalsAutoReminder.Title',
    'Admin.ApprovalsAutoReminder.NameLabel',
    'Admin.ApprovalsAutoReminder.Active',
    'Admin.ApprovalsAutoReminder.Inactive',
    'Admin.ApprovalsAutoReminder.TimeZoneLabel',
    'Admin.ApprovalsAutoReminder.StartTimeLabel',
    'Admin.ApprovalsAutoReminder.StopTimeLabel',
    'Admin.ApprovalsAutoReminder.StartInstantly',
    'Admin.ApprovalsAutoReminder.SpecificDate',
    'Admin.ApprovalsAutoReminder.NeverStops',
    'Admin.ApprovalsAutoReminder.SendRulesLabel',
    'Admin.ApprovalsAutoReminder.NumberOfQuotesWaitingForApproval',
    'Admin.ApprovalsAutoReminder.Date',
    'Msg.LogicAND',
    'Msg.LogicOR',
    'Admin.ApprovalsAutoReminder.ConditionLogic',
    'Admin.ApprovalsAutoReminder.OnSelectedEveryDayInterval',
    'Admin.ApprovalsAutoReminder.OnSelectedWeekDays',
    'Admin.ApprovalsAutoReminder.OnSelectedDaysInterval',
    'Admin.ApprovalsAutoReminder.DaysQuotesWaitingForApproval',
    'Admin.ApprovalsAutoReminder.DaysQuotesWaitingForApprovalMax',
    'Admin.ApprovalsAutoReminder.Days',
    'Admin.ApprovalsAutoReminder.Error.OneRuleMustBeActiveError',
    'Admin.ApprovalsAutoReminder.WillBeSentSettingsLabel',
    'Admin.ApprovalsAutoReminder.Frequency',
    'Admin.ApprovalsAutoReminder.Every',
    'Admin.ApprovalsAutoReminder.Days',
    'Admin.ApprovalsAutoReminder.Error.WeekDaysIntervalRequireAtLeastOneActiveDay',
    'Admin.ApprovalsAutoReminder.AtTime',
    'Admin.ApprovalsAutoReminder.IncludeBackupApprovers',
    'Admin.ApprovalsAutoReminder.RunSuccess',
    'Admin.ApprovalsAutoReminder.MinLimitForbidden',
    'Admin.ApprovalsAutoReminder.MaxLimitForbidden',

    // Approval Rules
    'xmlApprovalRules',
    'Admin.Approve_Conditions.QuickSearch',
    'Admin.Approve_Conditions.Name',
    'Admin.Approve_Conditions.AppConditionDesc',
    'Admin.Approve_Conditions.Group',
    'Admin.Approve_Conditions.User',
    'Admin.Approve_Conditions.Company',
    'Admin.Approve_Conditions.Condition',
    'Admin.Approve_Conditions.ApproveLogic',
    'Admin.Approve_Conditions.DelegationOfApprovals',
    'Admin.Approve_Conditions.AlternativeApprover',
    'Admin.Approve_Conditions.CanApproveRejectQuote',

    // Reassign Rights
    'xmlReassignRights',
    'Admin.ReassignRights.Columns.From',
    'Admin.ReassignRights.Columns.To',
    'Admin.ReassignRights.QuickSearch',
    'Admin.ReassignRights.DeleteMsg1',
    'Admin.ReassignRights.DeleteMsg2',
    'Admin.ReassignRights.DeleteWarning',
    'Admin.ReassignRights.Edit.Alert',
    'Admin.ReassignRights.Edit.UserType',
    'Admin.ReassignRights.Edit.ReassignTo',
    'Admin.ReassignRights.Edit.ReassignFrom',
    'Admin.ReassignRights.Edit.AvailableUserTypes',
    'Admin.ReassignRights.Edit.SelectedUserTypes',
    'Admin.ReassignRights.AllUserTypes',

    // Workflow Permissions
    'xmlWorkflowPermissions',
    'Admin.WorkflowPermissions.ListPermissions',
    'Admin.WorkflowPermissions.ByUserType',
    'Admin.WorkflowPermissions.ByAction',
    'Admin.WorkflowPermissions.QuickSearch',
    'Admin.WorkflowPermissions.UserTypes',
    'Admin.WorkflowPermissions.UserType',
    'Admin.WorkflowPermissions.ActionNames',
    'Admin.WorkflowPermissions.ActionName',
    'Admin.WorkflowPermissions.SelectUserTypes',
    'Admin.WorkflowPermissions.SelectActions',
    'Admin.WorkflowPermissions.AvailableListItems',
    'Admin.WorkflowPermissions.SelectedListItems',
    'Admin.WorkflowPermissions.SelectItems',
    'Admin.WorkflowPermissions.AvailableUserTypes',
    'Admin.WorkflowPermissions.SelectedUserTypes',
    'Admin.WorkflowPermissions.AvailableActions',
    'Admin.WorkflowPermissions.SelectedActions',
    'Admin.WorkflowPermissions.SelectUserTypes', 
    'Admin.WorkflowPermissions.SelectActions',
];
